import {
  bedtimeMenuItem,
  jpMenuItemData,
  menuItemData,
} from "../constants";
import { MarketType, SourceType, UserInformation } from "../../../types";

export default function buildMenuItems(
  market: MarketType | undefined,
  source: SourceType | null,
  segmentation: UserInformation["trialUserSegmentation"] | undefined,
) {
  const menuItems = [
    ...(market === "JP" ? jpMenuItemData : menuItemData),
  ];

  if (market === "HK" && source === SourceType.ClubApp)
    menuItems.splice(2, 0, bedtimeMenuItem);

  if (segmentation === "Action")
    return menuItems.filter(({ type }) => type !== "event");

  return menuItems;
}
